export default "__VITE_ASSET__Cxi3rFHr__"